// Le GLB "solution-card.glb" est identique pour toutes les cartes (seule la texture change) :
// on ne le charge/parse qu'une fois par URL, chaque scène clone ensuite ce template en mémoire.
const { GLTFLoader } = window.ThreeVendor;

const cache = new Map();

export function loadSolutionCardTemplate(modelUrl) {
	if (!cache.has(modelUrl)) {
		cache.set(modelUrl, new GLTFLoader().loadAsync(modelUrl).then((gltf) => gltf.scene));
	}
	return cache.get(modelUrl);
}
